module.exports = __webpack_public_path__ + "static/media/genealogie.f9efba5a.jpg";